import React,{useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual'
import RefundGiftCard from './RefundOption/RefundGiftCard'
import RefundEspece from './RefundOption/RefundEspece'
import RefundOther from './RefundOption/RefundOther'
import RefundOtherPaymentMode from './RefundOption/RefundOtherPaymentMode'
import {ControlAccess,FormatedPrice} from '@gull'
import axios from 'axios'
import swal from "sweetalert2";
import {DevpersoMaster} from "@devperso";
import { roundThePrice } from 'app/roundThePrice';
import { squarePaymentColors } from 'app/squarePaymentColors';
import { modePaiementCb } from 'app/modePaiementCb';
import { modePaiementDefaultAll } from 'app/modePaiementDefaultAll';
import {Tabs, Tab} from "react-bootstrap";

const RefundForm = (props) =>{
    const t =useTranslate()
    const [refundMode,setRefundMode]=useState(false)
    const [inputValue,setInputValue]=useState({
        inputBarCode:'',
        inputNoteOther:''
    }) 
    const [load,setLoad]=useState(false)
    const [errorPay,setErrorPay]=useState(false)
    const [isRestriction,setIsRestriction]=useState(false)
    const [refundTab,setRefundTab]=useState('espece')

    // Regroupement des modes de la section comme dans la fenêtre de paiement normale (TabSquareViewPay)
    const cbModes = props.refundPaymentMethod.filter(mode => modePaiementCb.includes(mode))
    const hasCheque = props.refundPaymentMethod.includes('cheque')
    const hasVirement = props.refundPaymentMethod.includes('virement')
    const customModes = props.refundPaymentMethod.filter(mode => !modePaiementDefaultAll.includes(mode))

    const idsLocalStorage=localStorage.getItem("pos").split(',')

    useEffect(function () {
        if(isRestriction){
            if(isRestriction=='other') props.setRestrictionRemboursementOther({...props.restrictionRemboursementOther,go:false})
            if(isRestriction=='espece') props.setRestrictionRemboursementEsp({...props.restrictionRemboursementEsp,go:false})
            setIsRestriction(false)
        }
    }, [refundMode])

    const refundApi = async (data) =>{
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0], data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                props.setCurrentTicket(response.data.data)
                setInputValue({
                    inputBarCode:'',
                    inputNoteOther:''
                })
                setLoad(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoad(false)
        setTimeout(()=>{
            setErrorPay(false)
        },1500)
    }

    const callback = () =>{
        if(refundMode=='other' || props.refundPaymentMethod.includes(refundMode)){
            props.setRestrictionRemboursementOther({...props.restrictionRemboursementOther,go:true})
            setIsRestriction('other')
        }
        if(refundMode=='espece'){
            props.setRestrictionRemboursementEsp({...props.restrictionRemboursementEsp,go:true})
            setIsRestriction('espece')
        }
    }
    
    return(<>
        {(!refundMode) ?
            <div style={{height:'80%'}}>
                <label className="fw-bold text-center d-block mb-3">{t('chooseRefundMethod')}</label>
                <Tabs activeKey={refundTab} id="refund-mode-tabs" onSelect={(k)=>setRefundTab(k)}>
                    <Tab eventKey="espece" title={t('espece')}>
                        <div className="payment-pad-grid mt-2">
                            <div className="payment-pad-cell payment-pad-cell--third">
                                <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:'#10B981'}} onClick={()=>setRefundMode('espece')}>
                                    <div className="textAlign">
                                        <div>{t('espece')}</div>
                                        <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    {(props.modulePos.params.gift_card.active) &&
                        <Tab eventKey="giftcard" title={<DevpersoMaster dp_direction={'GiftAvoir'}>{t('giftcardAvoir')}</DevpersoMaster>}>
                            <div className="payment-pad-grid mt-2">
                                <div className="payment-pad-cell payment-pad-cell--third">
                                    <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:'#F59E0B'}} onClick={()=>setRefundMode('giftcard')}>
                                        <div className="textAlign">
                                            <div>
                                                <DevpersoMaster
                                                    dp_direction={'GiftAvoir'}
                                                >
                                                    {t('giftcardAvoir')}
                                                </DevpersoMaster>
                                            </div>
                                            <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    }
                    {(cbModes.length!=0) &&
                        <Tab eventKey="card" title={t('card')}>
                            <div className="payment-pad-grid mt-2">
                                {cbModes.map((mode,index) => (
                                    <div className="payment-pad-cell payment-pad-cell--third" key={mode}>
                                        <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:squarePaymentColors[index % squarePaymentColors.length]}} onClick={()=>setRefundMode(mode)}>
                                            <div className="textAlign">
                                                <div>{t(mode)}</div>
                                                <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Tab>
                    }
                    {hasCheque &&
                        <Tab eventKey="cheque" title={t('cheque')}>
                            <div className="payment-pad-grid mt-2">
                                <div className="payment-pad-cell payment-pad-cell--third">
                                    <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:'#6D28D9'}} onClick={()=>setRefundMode('cheque')}>
                                        <div className="textAlign">
                                            <div>{t('cheque')}</div>
                                            <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    }
                    {hasVirement &&
                        <Tab eventKey="virement" title={t('virement')}>
                            <div className="payment-pad-grid mt-2">
                                <div className="payment-pad-cell payment-pad-cell--third">
                                    <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:'#0D9488'}} onClick={()=>setRefundMode('virement')}>
                                        <div className="textAlign">
                                            <div>{t('virement')}</div>
                                            <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    }
                    <Tab eventKey="other" title={t('other')}>
                        <div className="payment-pad-grid mt-2">
                            {customModes.map((mode,index) => (
                                <div className="payment-pad-cell payment-pad-cell--third" key={mode}>
                                    <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:squarePaymentColors[(index+cbModes.length) % squarePaymentColors.length]}} onClick={()=>setRefundMode(mode)}>
                                        <div className="textAlign">
                                            <div>{t(mode)}</div>
                                            <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div className="payment-pad-cell payment-pad-cell--third">
                                <div className="col-12 rounded raccourciPos text-white" style={{backgroundColor:'#6B7280'}} onClick={()=>setRefundMode('other')}>
                                    <div className="textAlign">
                                        <div>{t('other')}</div>
                                        <div><FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.total} /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </div>
        :
            <>
                <div className="mb-3 d-flex justify-content-between align-items-center">
                    {(refundMode=='espece') ? <label className="fw-bold text-center">{t('refundEspece')}</label> : false}
                    {(refundMode=='giftcard') ? <label className="fw-bold text-center"><DevpersoMaster dp_direction={'GiftAvoir'}>{t('refundGiftcard')}</DevpersoMaster></label> : false}
                    {(refundMode=='other') ? <label className="fw-bold text-center">{t('refundOther')}</label> : false}
                    {(props.refundPaymentMethod.includes(refundMode)) ? <label className="fw-bold text-center">{t('refund')+' '+t(refundMode)}</label> : false}
                    <button className="btn btn-sm btn-danger" onClick={()=>setRefundMode(false)}>{t('retour')}</button>
                </div>
                {((!props.restrictionRemboursementEsp.go && refundMode=='espece') || (!props.restrictionRemboursementOther.go && (refundMode=='other' || props.refundPaymentMethod.includes(refundMode)))) ?
                    <div style={{marginTop:'85px'}}>
                        <ControlAccess 
                            section={props.section} 
                            focus={true}
                            restriction={(refundMode=='espece') ? props.restrictionRemboursementEsp : props.restrictionRemboursementOther} 
                            setRestriction={(refundMode=='espece') ? props.setRestrictionRemboursementEsp : props.setRestrictionRemboursementOther} 
                            moduleId={props.posid} 
                            callback={callback}
                        />
                    </div>
                :
                    (refundMode=='giftcard') ?
                        <RefundGiftCard
                            total={(Number.isInteger(+props.total)) ? props.total : props.total.toFixed(props.digit)}
                            cookies={props.cookies}
                            currentTicket={props.currentTicket}
                            clientId={props.clientId}
                            inputValue={inputValue}
                            setInputValue={setInputValue}
                            errorPay={errorPay}
                            setErrorPay={setErrorPay}
                            load={load}
                            setLoad={setLoad}
                            refundApi={refundApi}
                        />
                    :
                        (refundMode=='espece') ?
                            <RefundEspece
                                total={(Number.isInteger(+props.total)) ? props.total : props.total.toFixed(props.digit)}
                                cookies={props.cookies}
                                load={load}
                                setLoad={setLoad}
                                refundApi={refundApi}
                                roundThePrice={roundThePrice}
                                digit={props.digit}
                                valeurArrondi={props.valeurArrondi}
                            />
                        :
                            (refundMode=='other') ?
                                <DevpersoMaster
                                    dp_direction={'RemboursementOther'}

                                    total={(Number.isInteger(+props.total)) ? props.total : props.total.toFixed(props.digit)}
                                    cookies={props.cookies}
                                    inputValue={inputValue}
                                    setInputValue={setInputValue}
                                    errorPay={errorPay}
                                    setErrorPay={setErrorPay}
                                    load={load}
                                    setLoad={setLoad}
                                    refundApi={refundApi}
                                    section={props.section}
                                >
                                    <RefundOther
                                        total={(Number.isInteger(+props.total)) ? props.total : props.total.toFixed(props.digit)}
                                        cookies={props.cookies}
                                        inputValue={inputValue}
                                        setInputValue={setInputValue}
                                        errorPay={errorPay}
                                        setErrorPay={setErrorPay}
                                        load={load}
                                        setLoad={setLoad}
                                        refundApi={refundApi}
                                    />
                                </DevpersoMaster>
                            :
                                (props.refundPaymentMethod.includes(refundMode)) ?
                                    <RefundOtherPaymentMode
                                        mode={refundMode}
                                        total={(Number.isInteger(+props.total)) ? props.total : props.total.toFixed(props.digit)}
                                        cookies={props.cookies}
                                        load={load}
                                        setLoad={setLoad}
                                        refundApi={refundApi}
                                    />
                                :
                                    false
                }
            </>
        }
    </>
    )
}

export default RefundForm;